export default "<img id=\"imageurl\" src={{newsEntity.activeImage}}  class=\"img\">\n"